/**
 * 极速卖车跟进记录
 */

import React, { Component } from 'react';
import { Modal, Form, Input, DatePicker } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';

import moment from 'moment';

const fields = [{
    "text": "跟进时间",
    "field": "recordTime",
    "date": true,
    "rules": [
        { required: true, message: '跟进时间不能为空!' },
    ]
}, {
    "text": "跟进情况",
    "field": "remark",
    "textarea": true,
    "rules": [
        { required: true, message: '跟进情况不能为空!' },
        { max: 128, message: '跟进情况不能超过128个字符！' },
    ]
}];


class FastSellRecordForm extends Component {

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            values["fastsellId"] = id;
            values["recordTime"] = values["recordTime"].format("YYYY-MM-DD HH:mm:ss");
            http.post({
                url: '/fastSell/addFollowRecord',
                data: values,
                success: (res) => {
                    if (this.props.successCallback) {
                        this.props.successCallback(id);
                    }
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field])) : editData[item.field],
                        })(
                            item.date ? <DatePicker format="YYYY-MM-DD HH:mm:ss" showTime={{ format: 'HH:mm:ss' }} style={{ width: '100%' }} />
                                : item.textarea ? <Input.TextArea />
                                    : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="极速卖车跟进记录"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const FastSellRecord = Form.create()(FastSellRecordForm);

export default FastSellRecord;